import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                <i className="ri-global-line"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                亚洲综合网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              亚洲综合网是专注亚洲地区的综合性信息平台，汇聚亚洲娱乐、财经、科技、生活等全品类内容，为用户提供最新、最全、最权威的亚洲资讯服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  用户协议
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-500 transition-all cursor-pointer" aria-label="RSS">
                <i className="ri-rss-line text-lg"></i>
              </a>
            </div>
            <p className="mt-6 text-sm text-background-500">
              联系邮箱：contact@985huidian.cn
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 亚洲综合网 版权所有
          </p>
          <p className="text-sm text-background-500">
            专注亚洲资讯，服务全球华人
          </p>
        </div>
      </div>
    </footer>
  );
}